<template>
    <div id="newGroup">
        <h5>请先添加组织，然后添加、管理云对象</h5>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="formInline">
                    <el-form-item>
                        <el-input v-model="formInline.group_name" placeholder="组织名称">
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-plus" type="primary" @click="onSubmit">新建组织</el-button>
                    </el-form-item>
                    </el-input>
                </el-form>
            </el-col>
            <!-- <el-col :span=6>
            </el-col> -->
        </el-row>
        <el-table :data="groups" height="350" style="width: 100%">
            <el-table-column label="组织名称" width="250">
                <template slot-scope="scope">
                    <span>{{ scope.row.group_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="添加单个对象">
                <template slot-scope="scope">
                    <el-button size="mini" icon='el-icon-plus' circle @click="pageToByfrom(scope.row)"></el-button>
                </template>
            </el-table-column>
            <el-table-column label="批量上传对象">
                <template slot-scope="scope">
                    <el-button size="mini" icon='el-icon-upload' circle @click="pageToUpload(scope.row)"></el-button>
                </template>
            </el-table-column>
            
            <el-table-column label="进入">
                <template slot-scope="scope">
                    <el-button size="mini" icon='el-icon-arrow-right' circle @click="pageToLists(scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="修改组织名称" :visible.sync="dialogVisible">
            <el-form>
                <el-form-item label="组织名称">
                    <el-input autocomplete="off" v-model="edit_group.group_name"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleEditGroup">修 改</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import axios from 'axios';
import config from '../config.js';

export default {
 
    data() {
        return {
            formInline: {
                group_name: ''
            },

            new_group: {
                group_id: '',
                group_name: '',
            },
            groups: [],
            dialogVisible: false,
            edit_group: ''
        }
    },
    created() {
        //console.log(config.base_url);
        this.checkLogin()
        //this.getGroups();
    },
    methods: {
        checkLogin() {
            let url = config.base_url + '/yun_table/users/islogin';
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                let res = response.data;
                if(res.login){
                    console.log('login true');
                    this.getGroups()
                }else{
                    console.log('login false');
                    this.$router.push({
                        'path': '/login'
                    })
                }
            })

            
        },
        getGroups() {
            let _this = this;
            axios.get(config.base_url + '/yun_table/yun_duixiang_groups', {
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    }
                })
                .then(function(response) {
                    _this.groups = response.data;
                });
        },
        //修改组织名称
        handleEdit(index, row) {
            //console.log(index, row.group_id)
            this.edit_group = row;
            this.dialogVisible = true;
        },
        handleEditGroup() {
            this.dialogVisible = false;
            let _this = this;
            axios({
                    method: 'put',
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    },
                    url: config.base_url + '/yun_table/yun_duixiang_groups/' + this.edit_group.group_id,
                    data: {
                        group_name: this.edit_group.group_name
                    }
                })
                .then(function(response) {
                    //console.log(response)
                    _this.$message({
                        message: '组织修改成功',
                        type: 'success'
                    });
                })
                .catch((err) => {
                    //console.log(err.response)
                    let err_data = err.response.data.err_msg
                    this.$message({
                        message: err_data,
                        type: 'error'
                    })
                })
        },
        handleDelete(index, row) {
            let _this = this;
            this.$confirm('此操作将永久删除该组织及所属所有对象, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                axios({
                        method: 'delete',
                        headers: {
                            "Authorization": localStorage.getItem('token')
                        },
                        url: config.base_url + '/yun_table/yun_duixiang_groups/' + row.group_id
                    }).then(function() {
                        _this.groups.splice(index, 1);
                        _this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    })
                    .catch((err) => {
                        //console.log(err.response)
                        let err_data = err.response.data.err_msg
                        this.$message({
                            message: err_data,
                            type: 'error'
                        })
                    })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    console.log(index, row.group_id)
                })
                .catch(_ => {});
        },
        //创建组织
        onSubmit() {
            let group_name = this.formInline.group_name;
            let _this = this;
            if (!group_name) {
                this.$message({
                    message: '请输入组织名称',
                    type: 'warning'
                });
            } else {
                axios({
                        method: 'post',
                        url: config.base_url + '/yun_table/yun_duixiang_groups',
                        headers: {
                            "Authorization": localStorage.getItem('token')
                        },
                        data: {
                            group_name: group_name
                        }
                    })
                    .then(function(response) {
                        //console.log(response)
                        _this.new_group = {
                            group_id: response.data.group_id,
                            group_name: response.data.group_name,
                        }
                        _this.groups.unshift(_this.new_group)
                        _this.formInline.group_name = ''
                        _this.$message({
                            message: '组织创建成功',
                            type: 'success'
                        });
                    })
                    .catch((err) => {
                        //console.log(err.response)
                        let err_data = err.response.data.err_msg
                        this.$message({
                            message: err_data,
                            type: 'error'
                        })
                    })
            }
        },
        pageToByfrom(group) {
            //console.log(group.group_id)
            this.$router.push({
                name: 'new_by_form',
                params: {
                    group_id: group.group_id
                }
            })
        },
        pageToUpload(group) {
            this.$router.push({
                name: 'upload',
                params: {
                    group_id: group.group_id,
                    group_name: group.group_name
                }
            })
        },
        pageToLists(group) {
            this.$router.push({
                name: 'duixianglists',
                params: {
                    group_id: group.group_id,
                    group_name: group.group_name
                }
            })
        }


    }

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#newGroup h5 {
    margin-top: 30px;
    margin-bottom: 30px;
}
</style>